











import { Component, Vue } from 'vue-property-decorator';
import Headline from '@/components/mobile/sections/Headline.vue';
import Anywhere from '@/components/mobile/sections/Anywhere.vue';
import Teachers from '@/components/mobile/sections/Teachers.vue';
import Administrators from '@/components/mobile/sections/Administrators.vue';
import Students from '@/components/mobile/sections/Students.vue';
import GetApp from '@/components/mobile/sections/GetApp.vue';

@Component({
  components: {
    Headline,
    Anywhere,
    Teachers,
    Administrators,
    Students,
    GetApp
  }
})
export default class Mobile extends Vue {
}
